module.exports = __webpack_public_path__ + "img/Thumbnails.253869f3.svg";